export default __webpack_public_path__ + "static/media/chart-bar.465cfb6f.svg";